module.exports = "pegasus_template/assets/blocks/landing-page-layout-06.png";